module.exports = __webpack_public_path__ + "static/media/GF5B有效载荷指标.2fb34a4a.png";